import React from 'react';
import BulletPoints from '../../BulletPoints';

const CommonPrivacyWithBullets = ({
  title,
  count,
  data,
  pl,
  id,
  handleOnClick,
}) => {
  return (
    <div className="mt-[30px] flex flex-col" id={id}>
      <p className="text22">
        {count}. <span className="pl-1">{title}</span>
      </p>
      <div className="flex flex-col gap-4">
        {data.map((info, index1) => (
          <React.Fragment key={index1}>
            <div
              className={`flex mt-4 gap-2`}
              style={{ paddingLeft: pl ? pl : '' }}
            >
              <p className="w-3 paragraphText text-[18px] font-bold">
                {info.id}.
              </p>
              <p className="w-[calc(100%-20px)] paragraphText text-[18px] font-bold">
                {info.name}
              </p>
            </div>
            <p
              className="smallText16Normal"
              key={index1}
              dangerouslySetInnerHTML={{ __html: info.text }}
              onClick={handleOnClick}
            ></p>
            {info.points && (
              <>
                {info.points.map((point, index4) => (
                  <BulletPoints
                    data={point}
                    key={index4}
                    pl="20px"
                    handleOnClick={handleOnClick}
                  />
                ))}
              </>
            )}
            {info.textBottom && (
              <>
                {info.textBottom.map((textT, index1) => (
                  <p
                    className="smallText16Normal"
                    key={index1}
                    dangerouslySetInnerHTML={{ __html: textT }}
                    onClick={handleOnClick}
                  ></p>
                ))}
              </>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default CommonPrivacyWithBullets;
